goog.provide('el8.uiwidget.Shade');

goog.require('el8.util.base');


/**
 * We use this to add a partial opacity cover over part of the page
 * (to "shadow" it). That is helpful when we want to visually focus
 * the user's eyes on a narrower part of the screen, which we
 * do, e.g., during FTUE walkthroughs and when dragging and dropping files.
 *
 * See FileUploader.js for an example.
 */
el8.uiwidget.Shade = function() {};

el8.uiwidget.Shade.prototype.show = function($elt, opts) {

    if (!$elt && !opts) { return; }

    opts = opts || {};
    var opacity,
        offsets,
        position,
        left, top,
        height, width,
        zIndex, backgroundColor,
        container, content;

    opacity = opts.opacity || 0;
    backgroundColor = opts.backgroundColor || 'white';
    container = opts.container || $('body');
    content = opts.content || null;

    if ($elt) {
        offsets = $elt.offset();
        left = offsets.left;
        top = offsets.top + (opts.top || 0);
        height = $elt.outerHeight(true);
        width = $elt.outerWidth(true);
        zIndex = el8.util.isNone(opts.zIndex) ? 1 : opts.zIndex;
    } else {
        left = opts.left;
        top = opts.top;
        height = opts.height;
        width = opts.width;
        zIndex = el8.util.isNone(opts.zIndex) ? 1 : opts.zIndex;
    }

    if (opts.scrollWithContainer) {
        position = 'absolute';
        var containerOffsets = container.offset();
        left -= containerOffsets.left;
        top -= containerOffsets.top;
    }
    else {
        position = 'fixed';
    }

    if (!this._overlay) {
        this._overlay = $('<div>');
        this._overlay.addClass('shade-overlay');
        /* Need to rely on caller to only provide HTML from a template */
        if (content) { this._overlay.html(content); }
        container.prepend(this._overlay);
        var that = this;
        if (opts.bindEvents) {
            opts.bindEvents.map(function(arg) {
                that.bind.apply(that, arg);
            });
        }
    }
    this._overlay.css({
        'opacity': opacity,
        'height': height,
        'width': width,
        'position': position,
        'left': left,
        'top': top,
        'background-color': backgroundColor,
        'z-index': zIndex
    });

    return this;
};

el8.uiwidget.Shade.prototype.hide = function() {
    if (this._overlay) {
        this._overlay.remove();
        this._overlay = null;
    }
};

el8.uiwidget.Shade.prototype.bind = function(e, fn) {
    if (this._overlay) {
        this._overlay.on(e, fn);
    }
};

el8.uiwidget.Shade.prototype.getOverlayElt = function() {
    return this._overlay;
};
